import React from 'react'

interface HeaderProps {
  children: React.ReactNode
  level?: 1 | 2 | 3 | 4 | 5
  className?: string
  centered?: boolean
  uppercase?: boolean
  color?: 'default' | 'primary' | 'secondary'
}

export function Header({
  children,
  level = 2,
  className = '',
  centered = false,
  uppercase = false,
  color = 'default',
}: HeaderProps) {
  const sizeStyles = {
    1: 'text-4xl md:text-5xl font-normal font-serif',
    2: 'text-3xl md:text-4xl font-normal font-serif',
    3: 'text-2xl md:text-3xl font-normal font-serif',
    4: 'text-xl md:text-2xl font-normal font-serif',
    5: 'text-lg md:text-xl font-medium tracking-wider font-sans',
  }

  const colorStyles = {
    default: 'text-gray-900',
    primary: 'text-primary',
    secondary: 'text-secondary',
  }

  const alignStyle = centered ? 'text-center' : ''
  const caseStyle = uppercase ? 'uppercase' : ''

  const headingClassName = `
    ${sizeStyles[level]}
    ${colorStyles[color]}
    ${caseStyle}
    leading-tight
    ${alignStyle}
    ${className}
  `.trim()

  const Tag = `h${level}` as keyof React.JSX.IntrinsicElements

  return (
    <Tag data-component-name="Header" className={headingClassName}>
      {children}
    </Tag>
  )
}
